exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chart-wrapper{position:relative}.chart-wrapper .high-charts{height:calc(100vh - 400px)}", ""]);

